import { render, staticRenderFns } from "./ContactRoles.vue?vue&type=template&id=515d1dc2&scoped=true"
import script from "./ContactRoles.vue?vue&type=script&lang=ts"
export * from "./ContactRoles.vue?vue&type=script&lang=ts"
import style0 from "./ContactRoles.vue?vue&type=style&index=0&id=515d1dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d1dc2",
  null
  
)

export default component.exports